import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Is this a physical product or a digital download?',
  answer: 'This is a 100% digital product delivered in high-quality PDF format. You can instantly access it from your computer, tablet, or smartphone immediately after purchase.'
}, {
  question: 'Is it suitable for new Occupational Therapists?',
  answer: 'Absolutely. The system is designed for both new grads who want a clear clinical structure and experienced professionals looking to save time and stay organized.'
}, {
  question: 'Can I use it with patients of all ages?',
  answer: 'Yes. The system includes specific adaptations and programs for pediatric, adult, and geriatric populations across a wide range of settings.'
}, {
  question: 'Can I adapt the plans to my own clinical style?',
  answer: 'Absolutely. Every session, program, and resource can easily be adapted to your patient’s specific needs, available equipment, and your personal clinical philosophy.'
}, {
  question: 'How quickly will I notice the benefits?',
  answer: 'Most OTs report saving hours of planning time and feeling significantly more organized from the very first week using the system.'
}, {
  question: 'What format are the resources delivered in?',
  answer: 'Your resources are delivered as high-quality digital PDFs that are easy to view, save, print, and reference from your computer, tablet, or smartphone.'
}, {
  question: 'Can I use the system for 1:1 and group sessions?',
  answer: 'Yes. The Therapy Session Builder includes flexible planning frameworks for individual sessions and therapy groups, with activities that can be graded to your setting and goals.'
}, {
  question: 'Can the documentation tools be adapted to my workplace?',
  answer: 'Yes. The templates are designed as practical starting points that you can adapt to your documentation standards, workflow, and professional judgment.'
}, {
  question: 'When do I receive the 5 premium bonuses?',
  answer: 'All 5 premium bonuses are included with your purchase and delivered instantly by email alongside the complete 6-in-1 system.'
}, {
  question: 'Is this a one-time payment, and how does the refund work?',
  answer: 'This is a one-time payment for instant access to the complete system and bonuses. If you are not satisfied, contact us within 7 days of purchase for a 100% refund.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-4 py-6" data-id="element-37" data-mp="2yms7xuiqi88i">
      <div className="mx-auto max-w-3xl" data-id="element-38" data-mp="2ylibtavfza4i">
        <h2 className="mb-4 text-center text-2xl font-extrabold uppercase sm:text-3xl" data-id="element-39" data-mp="2um9gi1kr746u">
          FREQUENTLY ASKED QUESTIONS
        </h2>
        <div className="space-y-2" data-id="element-40" data-mp="1n8y1m59pyf5z">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <article key={faq.question} className="overflow-hidden rounded-xl border border-brand-line bg-brand-cloud" data-id="element-41" data-mp="3uv7qi72250wz" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left transition-colors hover:bg-brand-mint sm:px-4" aria-expanded={isOpen} aria-controls={panelId} data-id="element-42" data-mp="2o18y7hrvzjf">
                  <span className="text-sm font-extrabold leading-snug text-brand-ink sm:text-base" data-id="element-43" data-mp="mcs3lvwknfza">{faq.question}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-blue transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-44" data-mp="qghp2chy9hg3" />
                </button>
                {isOpen && <div id={panelId} className="px-3 pb-3 text-sm font-medium leading-snug text-brand-slate sm:px-4" data-id="element-45" data-mp="2s95y52h9yz3s">
                    {faq.answer}
                  </div>}
              </article>;
        })}
        </div>
      </div>
    </section>;
}